import CronCore, { RenderlessSelect } from '@vue-js-cron/core';
import { CloseCircleFilled } from '@ant-design/icons-vue';
import { resolveComponent, openBlock, createBlock, mergeProps, withCtx, createElementVNode, createVNode, createElementBlock, Fragment, renderList, createTextVNode, toDisplayString, normalizeProps, guardReactiveProps, withModifiers, createCommentVNode, toHandlers } from 'vue';

var script$1 = {
  inheritAttrs: false,
  components: {
    RenderlessSelect,
    CloseCircleFilled
  },
  name: 'CustomSelect',
  props: {
    buttonProps: {
      type: Object,
      default: () => {}
    },
    dropdownProps: {
      type: Object,
      default: () => {}
    },
    hideOnClick: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      visible: false
    }
  },
  emits: ['update:model-value'],
  methods: {
    updateVisibility () {
      if (this.hideOnClick && this.visible) {
        this.visible = false;
      }
    }
  }
};

const _hoisted_1$1 = { class: "custom-select" };

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloseCircleFilled = resolveComponent("CloseCircleFilled");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_menu_item = resolveComponent("a-menu-item");
  const _component_a_menu = resolveComponent("a-menu");
  const _component_a_dropdown = resolveComponent("a-dropdown");
  const _component_renderless_select = resolveComponent("renderless-select");

  return (openBlock(), createBlock(_component_renderless_select, mergeProps(_ctx.$attrs, {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.$emit('update:model-value', $event)))
  }), {
    default: withCtx(({ selectedStr, itemRows, select, clearable, clear, modelValue, itemValue }) => [
      createElementVNode("span", _hoisted_1$1, [
        createVNode(_component_a_dropdown, mergeProps({
          trigger: ['click'],
          visible: _ctx.visible,
          "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.visible) = $event))
        }, $props.dropdownProps), {
          overlay: withCtx(() => [
            createVNode(_component_a_menu, {
              multiple: "",
              selectedKeys: Array.isArray(modelValue) ? modelValue : [modelValue]
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(itemRows, (itemRow, i) => {
                  return (openBlock(), createElementBlock("div", {
                    class: "vcron-a-row",
                    type: "flex",
                    key: i
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(itemRow, (item, j) => {
                      return (openBlock(), createElementBlock("div", {
                        class: "vcron-a-col",
                        flex: 1,
                        key: j
                      }, [
                        item
                          ? (openBlock(), createBlock(_component_a_menu_item, {
                              key: item[itemValue],
                              onClick: $event => {select(item); $options.updateVisibility();}
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(item.text), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                          : (openBlock(), createBlock(_component_a_menu_item, { key: 1 }))
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selectedKeys"])
          ]),
          default: withCtx(() => [
            createVNode(_component_a_button, normalizeProps(guardReactiveProps($props.buttonProps)), {
              default: withCtx(() => [
                createTextVNode(toDisplayString(selectedStr), 1 /* TEXT */),
                clearable
                  ? (openBlock(), createBlock(_component_CloseCircleFilled, {
                      key: 0,
                      onClick: [
                        $event => (clear()),
                        _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"]))
                      ]
                    }, null, 8 /* PROPS */, ["onClick"]))
                  : createCommentVNode("v-if", true)
              ]),
              _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["visible"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */))
}

script$1.render = render$1;
script$1.__scopeId = "data-v-04350d06";
script$1.__file = "src/components/CustomSelect.vue";

var script = {
  name: 'VueCronEditor',
  components: {
    CronCore: CronCore.component,
    CustomSelect: script$1
  },
  props: {
    buttonProps: {
      type: Object,
      default () {
        return {}
      }
    },
    cols: {
      type: Object,
      default: () => {
        return {
          minute: 5,
          hour: 4,
          day: 4
        }
      }
    }
  },
  emits: ['update:model-value', 'error']
};

const _hoisted_1 = { class: "vcron-a-spacer" };
const _hoisted_2 = { class: "vcron-a-spacer" };

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_custom_select = resolveComponent("custom-select");
  const _component_CronCore = resolveComponent("CronCore");

  return (openBlock(), createBlock(_component_CronCore, mergeProps(_ctx.$attrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.$emit('update:model-value', $event))),
    onError: _cache[1] || (_cache[1] = $event => (_ctx.$emit('error', $event)))
  }), {
    default: withCtx(({fields, period}) => [
      createElementVNode("div", null, [
        createTextVNode(toDisplayString(period.prefix) + " ", 1 /* TEXT */),
        createElementVNode("div", _hoisted_1, [
          createVNode(_component_custom_select, mergeProps(period.attrs, {
            items: period.items
          }, toHandlers(period.events), {
            "item-value": "id",
            "button-props": $props.buttonProps
          }), null, 16 /* FULL_PROPS */, ["items", "button-props"])
        ]),
        createTextVNode(" " + toDisplayString(period.suffix) + " ", 1 /* TEXT */),
        (openBlock(true), createElementBlock(Fragment, null, renderList(fields, (f) => {
          return (openBlock(), createElementBlock(Fragment, {
            key: f.id
          }, [
            createTextVNode(toDisplayString(f.prefix) + " ", 1 /* TEXT */),
            createElementVNode("div", _hoisted_2, [
              createVNode(_component_custom_select, mergeProps(f.attrs, toHandlers(f.events), {
                selection: f.selectedStr,
                cols: $props.cols[f.id],
                items: f.items,
                multiple: "",
                "button-props": $props.buttonProps,
                hideOnClick: false,
                clearable: ""
              }), null, 16 /* FULL_PROPS */, ["selection", "cols", "items", "button-props"])
            ]),
            createTextVNode(" " + toDisplayString(f.suffix), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */))
}

script.render = render;
script.__file = "src/CronEditor.vue";

// Import vue component

// Declare install function executed by Vue.use()
function install (Vue) {
  if (install.installed) return
  install.installed = true;
  Vue.component('CronAnt', script);
}

// Create module definition for Vue.use()
const plugin = {
  install,
  component: script,
  util: CronCore.util
};

export { script as CronAnt, plugin as CronAntPlugin, plugin as default, install };
